import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import resources from 'virtual:i18next-loader';
import { getEnv } from '@cidade360/core-lib/env';
// @ts-ignore - No type definitions available for i18next-emoji-postprocessor
import emoji from 'i18next-emoji-postprocessor';

const emojiEnabled = getEnv().EMOJI_ENABLED === 'true';

const i18nInstance = i18n.use(initReactI18next);

if (emojiEnabled) {
  i18nInstance.use(emoji);
}

i18n.services.formatter?.add('dados', (value: unknown) => {
  if (typeof value === 'string' && value.trim()) {
    return value;
  }

  return 'dados';
});

i18nInstance.init({
  resources,
  lng: 'pt',
  fallbackLng: 'pt',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  debug: import.meta.env.DEV,
  ...(emojiEnabled && { postProcess: 'emoji' }),
});

// Export both as default and named export
export { i18n };
export default i18n;
